module.exports = "<span (click)=\"toggle($event)\">{{sortTitle}}</span>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/common-module/components/sort-title/sort-title.component.html
// module id = ./src/app/modules/common-module/components/sort-title/sort-title.component.html
// module chunks = 9